export const CONSTANT_0 = 0
export const CONSTANT_1 = 1
export const CONSTANT_2 = 2
export const CONSTANT_3 = 3
export const CONSTANT_4 = 4
export const CONSTANT_5 = 5
export const CONSTANT_6 = 6
export const CONSTANT_7 = 7
export const CONSTANT_8 = 8
export const CONSTANT_9 = 9
export const CONSTANT_10 = 10
export const CONSTANT_11 = 11
export const CONSTANT_12 = 12
export const CONSTANT_13 = 13
export const CONSTANT_16 = 16
export const CONSTANT_21 = 21
export const CONSTANT_22 = 22
export const CONSTANT_99 = 99
// 状态
export const statusMap = new Map([
    [CONSTANT_99, '全部状态'],
    [CONSTANT_0, '等待下发'],
    [CONSTANT_2, '下发异常'],
    [CONSTANT_3, '重复线索'],
    [CONSTANT_1, '待清洗'],
    [CONSTANT_12, '未接通'],
    [CONSTANT_4, '无效线索'],
    [CONSTANT_5, '待分配'],
    [CONSTANT_11, '等待跟进'],
    [CONSTANT_6, '跟进中'],
    [CONSTANT_16, '到店'],
    [CONSTANT_21, '自然到店'],
    [CONSTANT_22, '邀约到店'],
    [CONSTANT_13, '已智驾'],
    [CONSTANT_8, '已订车'],
    [CONSTANT_9, '已成交'],
    [CONSTANT_7, '战败'],
    [CONSTANT_10, '休眠'],
])
export const statusTagMap = new Map([
    [CONSTANT_0, "info"],
    [CONSTANT_1, "success"],
    [CONSTANT_2, "warning"],
    [CONSTANT_3, "warning"],
    [CONSTANT_4, "warning"],
    [CONSTANT_5, "success"],
    [CONSTANT_6, "success"],
    [CONSTANT_7, "success"],
    [CONSTANT_8, "success"],
    [CONSTANT_9, "success"],
    [CONSTANT_10, "success"]
])

export const salesLevels = [
    { dataName: "4S" },
    { dataName: "4S(A)" },
    { dataName: "4S(B)" },
    { dataName: "专营店" },
    { dataName: "体验中心" },
    { dataName: "商超" },
    { dataName: "商超店" },
    { dataName: "城市体验店" },
    { dataName: "城市展厅" },
    { dataName: "销售展厅" },
]

export const remoteMap = new Map([
    [CONSTANT_0, "全部"],
    [CONSTANT_1, "是"],
    [CONSTANT_2, "否"],
    [CONSTANT_3, "空"],
]);

export const clueTypeMap = new Map([
    [CONSTANT_1, "线上"],
    [CONSTANT_2, "线下"],
]); 

export const showTimeStatusList = [CONSTANT_7, CONSTANT_12, CONSTANT_13, CONSTANT_16, CONSTANT_21, CONSTANT_22]

export const singleStatusList = [CONSTANT_7, CONSTANT_10, CONSTANT_13, CONSTANT_16, CONSTANT_21, CONSTANT_22, CONSTANT_99]

export const formRules = {
    source: [
        {
            required: true,
            message: "请选择渠道",
            trigger: "blur",
        },
    ],
    dealerCode: [
        {
            required: true,
            message: "请选择经销商",
            trigger: "blur",
        },
    ],
    phone: [
        {
            required: true,
            message: "请输入电话",
            trigger: "blur",
        },
    ],
    name: [
        {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
        },
    ],
    seriesId: [
        {
            required: true,
            message: "请选择车系",
            trigger: "blur",
        },
    ],
    paymentMoney: [
        {
            required: true,
            message: "请输入订金",
            trigger: "blur",
        },
    ],
}

export const flowTypeMap = new Map([
  [1, "经营-自然流量"],
  [2, "经营-广告直接线索"],
  [3, "经营-广告间接线索"],
  [4, "广告线索"],
  [0, "无"],
])